import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import API from "../../services/API";

import {
    AiOutlineChrome, AiOutlineInstagram,
    BiSupport,
  FaTelegramPlane,
    GiRotaryPhone,

    ImUserTie,
    RiMapPinLine,

} from "react-icons/all";

class Contact extends Component {
    state = {
        data: [],
        isLoaded: false,
    }
    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={0} title='اطلاعات تماس '/>
                {
                    !this.state.isLoaded && <Loading/>
                }
                <section className="container mt-2 py-5">
                    <div className="row mt-4 rtl px-1 menu-list-item"  >

                        <div className="col-1">
                            <ImUserTie className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                            شماره تماس مدیر
                        </div>
                        <div className="col-6 text-white text-right">
                            {this.state.data.modir}
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-1 menu-list-item"  >
                        <div className="col-1">
                            <BiSupport className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                            شماره پشتیبانی
                        </div>
                        <div className="col-6 text-white text-right text-small-2">
                            {this.state.data.poshtibani}
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-1 menu-list-item"  >
                        <div className="col-1">
                            <GiRotaryPhone className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                            شماره ثابت
                        </div>
                        <div className="col-6 text-white text-right text-small-2">
                            {this.state.data.phone}
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-1 menu-list-item"  >
                        <div className="col-1">
                            <RiMapPinLine className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                             آدرس
                        </div>
                        <div className="col-6 text-white text-right text-small-2">
                            {this.state.data.address}
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-1 menu-list-item"  >
                        <div className="col-1">
                            <AiOutlineChrome className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                             وب سایت
                        </div>
                        <div className="col-6 text-white text-right text-small-2">
                            <a href={`http://${this.state.data.sait}`}  className='text-info text-decoration-none text-capitalize' target="_blank" rel="noreferrer">
                                {this.state.data.sait}
                            </a>
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-1 menu-list-item"  >
                        <div className="col-1">
                            <AiOutlineInstagram className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                            اینستاگرام
                        </div>
                        <div className="col-6 text-white text-right text-small-2">
                            <a href={`https://instagram.com/${this.state.data.instagram}`}  className='text-info text-decoration-none text-capitalize' target="_blank" rel="noreferrer">
                                {this.state.data.instagram}
                            </a>
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-1 menu-list-item"  >
                        <div className="col-1">
                            <FaTelegramPlane className="text-primary-color list-icon"/>
                        </div>
                        <div className="col-4 text-white text-small-2 pt-1 ">
                            تلگرام
                        </div>
                        <div className="col-6 text-white text-right text-small-2">
                            <a href={`https://t.me/${this.state.data.telgram}`}  className='text-info text-decoration-none text-capitalize' target="_blank" rel="noreferrer">
                                {this.state.data.telgram}
                            </a>
                        </div>
                    </div>
                </section>
                <Navbar/>
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        API.getContactInfo()
            .then((response) => {
                // console.log(response.contact[0])
                this.setState({isLoaded: true, 'data': response.contact[0]})
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default Contact;